var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{style:('border-right: none !important; border-top: none !important; border-bottom: none !important; border-left: 5px solid !important; margin-left:' + _vm.marginLeft + ';'),attrs:{"color":_vm.color,"value":"true","outline":""}},[_c('div',{style:(_vm.getTextColor)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }